if (typeof boostPFSThemeConfig !== 'undefined') {
	// Override Settings
	var boostPFSFilterConfig = {
		general: {
			limit: boostPFSConfig.custom.products_per_page,
			loadProductFirst: false,
            paginationType: 'default',
            enableSeo: false,
		}
	};
}

(function () {
	var onSale = false,
		soldOut = false,
		priceVaries = false,
		images = [],
		boostPFSRangeWidths = [165, 360, 533, 720, 940, 1066];


	BoostPFS.inject(this);

	/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	function prepareShopifyData(data) {
		// Displaying price base on the policy of Shopify, have to multiple by 100
		soldOut = !data.available; // Check a product is out of stock
		onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Convert images to array
		images = data.images_info;
		// Get First Variant (selected_or_first_available_variant)
		firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function (e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		return data;
	}

	/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	/************************** BUILD PRODUCT LIST **************************/
	// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function (data) {
		if (!data) data = this.data;
		// Customize API data to get the Shopify data
		data = prepareShopifyData(data);

		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;

        itemHtml = itemHtml.replace(/{{itemGridClass}}/g, boostPFSThemeConfig.custom.product_per_row);

        // Add Item Labels
        var itemLabels = '';
        if (onSale) {
          itemLabels += boostPFSTemplate.saleLabelHtml;
        }

        if (soldOut) {
          itemLabels += boostPFSTemplate.soldOutLabelHtml;
        }

        if (boostPFSThemeConfig.custom.product_badges.length > 0) {
          for (let i = 0; i < data.tags.length; i++) {
            var tag = data.tags[i].split(':');
            if (boostPFSThemeConfig.custom.product_badges.indexOf(tag[0]) > -1) {
              itemLabels += boostPFSTemplate.tagLabelHtml.replace('{{itemTagLabel}}', tag[1]);
            }
          }
          
        }
        itemHtml = itemHtml.replace(/{{itemLabels}}/g, itemLabels);

        // Add Item Image
        var itemImages = '';
        itemImages += '<a href="{{itemUrl}}" class="d-block product-link" >';
        itemImages += '<picture>';
        itemImages += '<source media="(max-width:150px)" srcset="' + Utils.getFeaturedImage(images, '360x') + '">';
        itemImages += '<source media="(max-width:270px)" srcset="' + Utils.getFeaturedImage(images, '360x') + '">';
        itemImages += '<source media="(max-width:360px)" srcset="' + Utils.getFeaturedImage(images, '360x') + '">';
        itemImages += '<source media="(max-width:535px)" srcset="' + Utils.getFeaturedImage(images, '535x') + '">';
        itemImages += '<source media="(max-width:750px)" srcset="' + Utils.getFeaturedImage(images, '535x') + '">';
        itemImages += '<source media="(max-width:900px)" srcset="' + Utils.getFeaturedImage(images, '535x') + '">';
        itemImages += '<source media="(max-width:1200px)" srcset="' + Utils.getFeaturedImage(images, '535x') + '">';
        itemImages += '<source media="(max-width:1920px)" srcset="' + Utils.getFeaturedImage(images, '535x') + '">';
        itemImages += '<img src="' + Utils.getFeaturedImage(images) + '" alt="' + Utils.escape(images[0] ? images[0]['alt'] : data.title) + '" loading="lazy" data-feauredImage width="' + (images[0] ?images[0]['width'] : '100') + '" height="' + (images[0] ? images[0]['height'] : '100') + '">';
        itemImages += '</picture>';
        itemImages += '</a>';
        itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImages);

        // Add Item Price
        var itemPrice = '';
        itemPrice += '<span class="fw-extra-bold m-0 money p-0 price text-primary" data-currentPrice>' + Utils.formatMoney(data.price_min) + '</span>';
        if (onSale) {
          itemPrice += '<s class="fw-medium font-size-sm m-0 me-1 money ms-1 ms-md-2 p-0 price small text-gray-500 compare_at_price" data-comparePrice>' + Utils.formatMoney(data.compare_at_price_min) + '</s>';
        }
        itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPrice);

		// Add Review
		// if (typeof Integration === 'undefined' ||
		// 	(typeof Integration != 'undefined' &&
		// 		typeof Integration.hascompileTemplate == 'function' &&
		// 		!Integration.hascompileTemplate('reviews'))) {
		// 	itemHtml = itemHtml.replace(/{{itemReviews}}/g, '');
		// }
        let rukSnippetHtml = `<div class="ruk_rating_snippet" data-sku="${data.handle};${data.variants.map(v=>v.sku).join(';')};${data.variants.map(v=>v.id).join(';')}"></div>`;
        itemHtml = itemHtml.replace(/{{itemReviews}}/g, rukSnippetHtml);

				// Okendo Review
				let okendoSnippet = data.metafields.okendo?.StarRatingSnippet;
				if (!okendoSnippet) {
					okendoSnippet = '';
				}
				let okendoReviewHtml = `<div data-oke-star-rating data-oke-reviews-product-id="shopify-${data.id}">${okendoSnippet}</div>`
				itemHtml = itemHtml.replace(/{{itemReviewsOkendo}}/g, okendoReviewHtml);

		// Add Vendor
        var itemVendor = '';
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendor);

        var itemSwatches = '';
        if (boostPFSThemeConfig.custom.enable_product_card_swatches) {
          itemSwatches += '';
        } else {
          itemSwatches += '<input type="hidden" name="quantity" value="1" />';
          itemSwatches += '<input type="hidden" name="id" value="' + data.variants[0]['id'] + '" />';
        }
        itemHtml = itemHtml.replace(/{{itemSwatches}}/g, itemSwatches);

		// Add main attribute (Always put at the end of this function)
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrlWithVariant(data));
		return itemHtml;
	};

	/************************** END BUILD PRODUCT LIST **************************/
	/************************** BUILD PRODUCT ITEM ELEMENTS **************************/
  
	/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
	/************************** BUILD TOOLBAR **************************/
	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
		// If it has only one page, clear Pagination
		if (totalPage <= 1) {
			return '';
		}

		var paginationHtml = boostPFSTemplate.paginateHtml;
		// Build Previous
		var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : '';
		previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
		paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
		// Build Next
		var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : '';
		nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
		paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
		// Create page items array
		var beforeCurrentPageArr = [];
		for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
			beforeCurrentPageArr.unshift(iBefore);
		}
		if (currentPage - 4 > 0) {
			beforeCurrentPageArr.unshift('...');
		}
		if (currentPage - 4 >= 0) {
			beforeCurrentPageArr.unshift(1);
		}
		beforeCurrentPageArr.push(currentPage);
		var afterCurrentPageArr = [];
		for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
			afterCurrentPageArr.push(iAfter);
		}
		if (currentPage + 3 < totalPage) {
			afterCurrentPageArr.push('...');
		}
		if (currentPage + 3 <= totalPage) {
			afterCurrentPageArr.push(totalPage);
		}
		// Build page items
		var pageItemsHtml = '';
		var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
		for (var iPage = 0; iPage < pageArr.length; iPage++) {
			if (pageArr[iPage] == '...') {
				pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
			} else {
				pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
			}
			pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
			pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
		}
		paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
		return paginationHtml;
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function () {
		var html = '';
		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				var paramSort = Globals.queryParams.sort || '';
				// Build content
				var sortingItemsHtml = '';
                var i = 0;
				for (var k in sortingArr) {
                    i++;
					var isSelected = '';
                    var isChecked = '';
					if(paramSort == k) {
						isSelected = 'selected';
                        isChecked = 'checked';
					}
                    sortingItemsHtml += '<li data-value="' + k + '" class="form-check py-1 ' + isSelected + '">';
                    sortingItemsHtml += '<input type="radio" value="' + k + '" class="sortby_options form-check-input" name="custom_sort_by_desktop" id="custom_sort_by-desktop-' + i + '" ' + isChecked + '/>';
                    sortingItemsHtml += '<label for="custom_sort_by-desktop-' + i + '" class="option_txt form-check-label" title="' + sortingArr[k] + '">' + sortingArr[k] + '</label>';
                    sortingItemsHtml += '</li>';
					// sortingItemsHtml += '<option value="' + k + '"' + isSelected + '>' + sortingArr[k] + '</option>';
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}
		return html;
	};

	ProductSorting.prototype.render = function () {
		jQ(Selector.topSorting).html(this.compileTemplate());

		if (jQ('.boost-pfs-filter-custom-sorting').hasClass('boost-pfs-filter-sort-active')) {
			jQ('.boost-pfs-filter-custom-sorting').toggleClass('boost-pfs-filter-sort-active');
		}

		var labelSort = '';
		var paramSort = Globals.queryParams.sort || '';
		var sortingList = Utils.getSortingList();
		if (paramSort.length > 0 && sortingList && sortingList[paramSort]) {
			labelSort = sortingList[paramSort];
		} else {
			labelSort = Labels.sorting;
		}

		jQ('.boost-pfs-filter-top-sorting-label').text(labelSort);
	}

	// Build Sorting event
	ProductSorting.prototype.bindEvents = function() {
		jQ(Selector.topSorting + ' label').click(function(e) {
			e.preventDefault();
            var $parent = jQ(this).parent();
			FilterApi.setParam('sort', $parent.find('input').val());
			FilterApi.setParam('page', 1);
			FilterApi.applyFilter('sort');
		});
	};

  // Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function(data) {
		if (!data) data = this.data;

        if (boostPFSThemeConfig.custom.enable_product_card_swatches) {
          this.buildExtrasProductListByAjax(data, 'boost-integration', function(results) {
              results.forEach(function(result) {
                  var $cardFooter = jQ('.card-main-wrapper[data-id="' + result.id + '"]').find('.card-footer');
                  $cardFooter.html(result.swatch);                  
              });
          });
        }
        
	}

	// Build Additional Elements
	Filter.prototype.afterRender = function(data, eventType) {
		if (!data) data = this.data;

        var html = 'Showing {{ startingPage }} - {{ currentProductsCount }} of {{ products_count }} products';
        var startPage = ((Globals.queryParams.page - 1) * Globals.queryParams.limit) + 1;
        var currentProduct = (Globals.queryParams.page * Globals.queryParams.limit) + 1;
        if (currentProduct >= data.total_product) {
          currentProduct = data.total_product;
        }
        html = html.replace('{{ startingPage }}', startPage).replace('{{ currentProductsCount }}', currentProduct);
		jQ('.boost-pfs-filter-total-product').html(html.replace('{{ products_count }}', data.total_product));
	};

    FilterMobileButton.prototype.afterRender = function() {
      var self = this;
      
      jQ('#filter-drawer').off('click').click(function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        self.onClick.call(self);
        // setTimeout(function() {
        //   jQ('.collection-filter__btn').removeClass('is-active');
        //     jQ('html').removeClass('lock-scroll');
        // }, 100);
      });
    }
/*
    FilterApi.beforeCall = function(eventType, eventInfo) {
        if (!Globals.queryParams.hasOwnProperty('pf_t_universal')) {
            // Globals.queryParams.pf_t_universal.push('non-universal');
            Globals.queryParams.pf_t_universal = ['non-universal'];
        } else {
            // Globals.queryParams.pf_t_universal = ['non-universal'];
        }
        
        if (Utils.isCollectionPage() && eventType == 'init') {
            Globals.queryParams.pf_t_universal = ['universal', 'non-universal'];
        }
        
    }


    FilterRefineByItem.prototype.afterRender = function () {
      if (this.filterItemId == "non-universal") {
        this.$element.hide();
      }
    }
    */

  // Callback function before filter tree is rendered
    // Filter.prototype.afterRender = function() {
    //     // console.log(this.data)
    //   jQ('a.boost-pfs-filter-close').html('X');
    // }

     FilterTree.prototype.getHeaderTemplate = function() {
		return `
			<div class="boost-pfs-filter-mobile-toolbar">
				<div class="boost-pfs-filter-mobile-toolbar-top">
					<a href="javascript:;" style="display: flex; justify-content:center; align-items:center;" class="{{class.closeFilterButton}}"><i style="font-size: 20px;" class="fa fa-times"></i></a>
				</div>
				<div class="boost-pfs-filter-mobile-toolbar-header">{{label.refineMobile}}</div>
				<div class="boost-pfs-filter-mobile-toolbar-bottom">
					{{clearButton}}
				</div>
			</div>
		`.trim();
	}

	/************************** END BUILD TOOLBAR **************************/
})();
